import { useEffect, useState } from "react";
import { siteRequestHeaders } from '../lib/siteRequestHeaders';

export const useKickStatus = (enabled = true) => {
  const [status, setStatus] = useState({ state: "unknown", url: process.env.REACT_APP_KICK_CHANNEL_URL });
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    const controller = new AbortController();
    const load = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/kick/status`, { signal: controller.signal, headers: siteRequestHeaders() });
        if (!response.ok) throw new Error("Status unavailable");
        const data = await response.json();
        if (active) setStatus(data);
      } catch {
        if (active) setStatus((previous) => ({ ...previous, state: "unknown" }));
      }
    };
    load();
    const timer = setInterval(load, 60000);
    return () => { active = false; controller.abort(); clearInterval(timer); };
  }, [enabled]);
  return status;
};